<div class="container">
<div id="message">
  <h2 id="status">{{pageMessage}}</h2>
</div>
</div>
